import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { select, Store } from '@ngrx/store';
import { CustomerStorageService } from '../../../../account/services/customer-storage.service';
import { CustomerInterface } from '../../../../account/models/customer.interface';
import { MissionReportsInterface, ReportInterface } from '../../../models/export-billing-status.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DownloadFile, GetBills } from '../../../../bills/store/actions/bills.actions';
import { SaveCustomerMission } from '../../../store/actions/customer-mission.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import moment from 'moment';
import { environment } from '../../../../../../environments/environment';
import { TokenLocalStorageService } from '../../../../authentication/services/token-local-storage.service';
import { LoginResponseInterface } from '../../../../authentication/models/login-response.interface';
import { BillsInterfaceState } from '../../../../bills/store/state/bills.state';

@Component({
  selector: 'app-export-billing-status',
  templateUrl: './export-billing-status.component.html',
  styleUrls: ['./export-billing-status.component.css'],
  standalone: false
})
export class ExportBillingStatusComponent implements OnInit {

  @Input()
  procedureCode: string;

  @Input()
  message: any;

  errors: any = {
    period: {
      required: `Ce champ est obligatoire.`,
      pattern: 'Veuillez saisir une période au bon format MM/AAAA.'
    },
  };
  customer: CustomerInterface;
  reportsForm: FormGroup;
  reportsFormSubmitted: boolean;
  noConsumption: boolean;
  period: string;
  showError: boolean;
  missionReports: MissionReportsInterface = null;
  brand?: string;
  communicationDetailsReport: boolean;
  billingAnalysisReport: boolean;
  invalidPeriod: boolean;
  connectedUser: LoginResponseInterface;
  latestBillDate: string|null;
  currentYear: any;

  constructor(
    private store: Store<any>,
    private formBuilder: FormBuilder,
    private customerStorage: CustomerStorageService,
    private tokenLocalStorageService: TokenLocalStorageService,
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.currentYear = new Date().getFullYear();
    this.reportsFormSubmitted = false;
    this.customer = this.customerStorage.getCustomer();
    this.connectedUser = this.tokenLocalStorageService.getToken();
    this.noConsumption = false;
    this.showError = false;
    this.communicationDetailsReport = false;
    this.invalidPeriod = false;
    this.billingAnalysisReport = false;
    this.initForm();
    this.missionReports = this.message.data;
    this.latestBillDate = null;
    this.store.pipe(select(ConstsHelper.REDUCER_BILLS)).subscribe((response: BillsInterfaceState) => {
      if (response.bills instanceof Array && response.bills.length > 0) {
        this.latestBillDate = response.bills[0].date;
      }
    });
    this.store.dispatch(new GetBills());
  }

  initForm() {
    this.reportsForm = this.formBuilder.group({});
    this.reportsForm.addControl('billingStatus', this.formBuilder.control('', []));
    this.reportsForm.addControl('communicationDetails', this.formBuilder.control('', []));
    this.reportsForm.addControl('billingAnalysis', this.formBuilder.control('', []));
    this.reportsForm.addControl('period', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.periodDatePattern)]));
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  downloadReportHandler(fileId: number, reportName: string) {
    this.store.dispatch(new DownloadFile(fileId, 'billing_report', reportName, 'application/octet-stream'));
  }

  save() {
    this.reportsFormSubmitted = true;
    this.communicationDetailsReport = false;
    this.billingAnalysisReport = false;
    this.invalidPeriod = false;
    if (this.reportsForm.valid) {
      /** No report choice detected */
      if (
        this.reportsForm.get('billingStatus').value === '' &&
        this.reportsForm.get('communicationDetails').value === '' &&
        this.reportsForm.get('billingAnalysis').value === ''
      ) {
        this.showError = true;
      } else if (
        moment(this.reportsForm.get('period').value, 'MM/YYYY').format('YYYYMM') > moment().format('YYYYMM') ||
        moment(this.reportsForm.get('period').value, 'MM/YYYY').format('YYYYMM') <= moment('02/2024', 'MM/YYYY').format('YYYYMM') ||
        (
            this.latestBillDate != null &&
            moment(this.reportsForm.get('period').value, 'MM/YYYY').format('YYYYMM') > moment(this.latestBillDate, 'DD/MM/YYYY').format('YYYYMM')
        )
      ) {
        this.invalidPeriod = true;
      } else {
        this.showError = false;
        const reportsObject: Array<ReportInterface> = [];
        for (const [key, value] of Object.entries(this.reportsForm.getRawValue())) {
          if (key !== 'period' && value === true) {
            reportsObject.push({
              report_name: key,
              period: moment(this.reportsForm.get('period').value, 'MM/YYYY').format('YYYYMM'),
              no_consumption: key === 'billingStatus' ? this.noConsumption : null
            });
          }
        }

        if (reportsObject.length === 0) {
          this.showError = true;
        } else {
          this.showError = false;

          if (this.reportsForm.get('communicationDetails').value) {
            const reportFound = this.missionReports.reports.find( report => report.report_name.includes('Synthèse détaillée'));
            if (reportFound && reportFound.period === moment(this.reportsForm.get('period').value, 'MM/YYYY').format('YYYYMM')) {
              this.communicationDetailsReport = true;
            }
          } else {
            this.communicationDetailsReport = false;
          }

          if (this.reportsForm.get('billingAnalysis').value) {
            const reportFound = this.missionReports.reports.find( report => report.report_name.includes('Synthèse complète'));
            if (reportFound && reportFound.period === moment(this.reportsForm.get('period').value, 'MM/YYYY').format('YYYYMM')) {
              this.billingAnalysisReport = true;
            }
          } else {
            this.billingAnalysisReport = false;
          }

          if (!this.communicationDetailsReport && !this.billingAnalysisReport) {
            this.store.dispatch(new SaveCustomerMission({reports: reportsObject, email: this.connectedUser.email}, this.procedureCode, 'account'));
          }

        }
      }
    }
  }

  optionHandler(event: any) {
    this.noConsumption = JSON.parse(event.currentTarget.value);
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.reportsForm.controls[formControlName].invalid) {
      Object.keys(this.reportsForm.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }
}
